import { ComponentsOverrides, Theme } from "@mui/material";
import palette from "./palette";

type MuiMenuItemOverrides = {
  styleOverrides: ComponentsOverrides<Theme>["MuiMenuItem"];
};

const MuiMenuItem: MuiMenuItemOverrides = {
  styleOverrides: {
    root: {
      padding: "8px 16px",
      "&:hover, &:active": {
        backgroundColor: palette.primary.states.hover,
      },
      "&&.Mui-selected": {
        backgroundColor: palette.primary.states.hover,
      },
    },
    dense: { padding: "4px 16px" },
  },
};

export { MuiMenuItem };
